// Simple internal diagnostic logging mechanism for debugging in-app purchases and system behavior
// Stores logs in window for cross-component access and dispatches events for live UI updates

export interface DiagnosticLog {
    timestamp: string;
    level: 'info' | 'warn' | 'error' | 'success';
    module: string;
    message: string;
    details?: string;
}

if (typeof window !== 'undefined') {
    (window as any).__app_logs = (window as any).__app_logs || [];
}

export const getLogs = (): DiagnosticLog[] => {
    if (typeof window === 'undefined') return [];
    return (window as any).__app_logs || [];
};

export const clearLogs = () => {
    if (typeof window === 'undefined') return;
    (window as any).__app_logs = [];
    window.dispatchEvent(new CustomEvent('app-log-updated'));
};

export const logDiagnostic = (
    level: 'info' | 'warn' | 'error' | 'success',
    module: string,
    message: string,
    details?: any
) => {
    const timestamp = new Date().toLocaleTimeString();
    
    let detailsStr = '';
    if (details) {
        if (details instanceof Error) {
            detailsStr = `${details.name}: ${details.message}\n${details.stack || ''}`;
        } else if (typeof details === 'object') {
            try {
                detailsStr = JSON.stringify(details, null, 2);
            } catch (e) {
                detailsStr = String(details);
            }
        } else {
            detailsStr = String(details);
        }
    }

    const newLog: DiagnosticLog = {
        timestamp,
        level,
        module,
        message,
        details: detailsStr || undefined
    };

    // Output to normal developer console
    const prefix = `[${module}] [${level.toUpperCase()}]`;
    if (level === 'error') {
        console.error(prefix, message, details || '');
    } else if (level === 'warn') {
        console.warn(prefix, message, details || '');
    } else {
        console.log(prefix, message, details || '');
    }

    if (typeof window !== 'undefined') {
        (window as any).__app_logs = (window as any).__app_logs || [];
        // Prepend new logs to show latest first, keep last 200 logs
        (window as any).__app_logs = [newLog, ...(window as any).__app_logs].slice(0, 200);
        
        // Notify components
        window.dispatchEvent(new CustomEvent('app-log-updated'));
    }
};
